import { BaseMole } from "../BaseMole";
import { MoleAnimationController, MoleAnimationState } from "../MoleAnimationController";
import { DieState } from "./DieState";
import { FreezeState } from "./FreezeState";
import { IMoleState } from "./IMoleState";

export class AttackState implements IMoleState {
    private attackTimes: number;
    private throwingInProgress: boolean;

    public constructor(
        private readonly mole: BaseMole,
        private readonly animationController: MoleAnimationController,
        private readonly afterAttackState: IMoleState,
        private readonly dieState: DieState,
        private readonly freezeState: FreezeState,
        private readonly attackCount: number
    ) {
        this.throwingInProgress = false;
    }

    public enter(previousState: IMoleState): void {
        this.animationController.onClipEnd.add(this.handleClipEnd, this);
        this.animationController.onAnimationProgress.add(this.waitForCorrectThrowFrame, this);
        if (!(previousState instanceof FreezeState)) {
            this.throwingInProgress = false;
            this.attackTimes = 0;
            this.mole.equipProjectile();
            this.animationController.transitToState(MoleAnimationState.Throw);
        }
    }

    private async handleClipEnd(_state: MoleAnimationState): Promise<void> {
        this.attackTimes++;
        this.throwingInProgress = false;
        if (this.attackTimes < this.attackCount) {
            this.mole.equipProjectile();
            this.animationController.transitToState(MoleAnimationState.Throw);
        }
    }

    private waitForCorrectThrowFrame(state: MoleAnimationState, progress: number): void {
        if (state != MoleAnimationState.Throw || this.throwingInProgress) {
            return;
        }
        if (progress > 0.4) {
            this.throwingInProgress = true;
            this.mole.throw();
        }
    }

    public exit(): void {
        this.animationController.onClipEnd.remove(this.handleClipEnd, this);
        this.animationController.onAnimationProgress.remove(this.waitForCorrectThrowFrame, this);
    }

    public process(_dt: number): IMoleState {
        if (!this.mole.alive) {
            return this.dieState;
        }
        if (this.mole.freezed) {
            return this.freezeState;
        }
        if (this.attackTimes == this.attackCount) {
            return this.afterAttackState;
        }
        return this;
    }

}